/**
 * Week and day, under Plan (decision B09, Ronald, 27 September 2026: the top
 * tab is named "Plan", and the week and the day sit under it). Two links
 * rather than a toggle, because each view has its own address; the one on
 * screen is marked `aria-current`, which a screen reader announces and the
 * style shows by weight and a border as well as by colour (WCAG 1.4.1).
 */
import { Link } from "react-router-dom";

export function PlanSwitch({
  current,
  weekTo,
  dayTo,
}: {
  current: "week" | "day";
  weekTo: string;
  dayTo: string;
}) {
  return (
    <nav aria-label="Plan view" className="plan-switch">
      <Link
        aria-current={current === "week" ? "page" : undefined}
        className="plan-switch__item"
        to={weekTo}
      >
        Week
      </Link>
      <Link
        aria-current={current === "day" ? "page" : undefined}
        className="plan-switch__item"
        to={dayTo}
      >
        Day
      </Link>
    </nav>
  );
}
